import { PlanningGroup } from '@/services/PlanningService';

const includesText = (value: unknown, query: string): boolean => {
  if (value === null || value === undefined) {
    return false;
  }

  return String(value).toLowerCase().includes(query);
};

export const filterPlanningGroupsBySearch = (
  groups: PlanningGroup[],
  searchQuery: string
): PlanningGroup[] => {
  const normalized = searchQuery.trim().toLowerCase();
  if (!normalized) {
    return groups;
  }

  return groups
    .map((group) => {
      const groupMatches = includesText(group.groupIdentifier, normalized) || includesText(group.title, normalized);
      if (groupMatches) {
        return group;
      }

      const nextLineItems = group.lineItems?.filter((lineItem) => {
        return (
          includesText(lineItem.lineItem, normalized)
          || includesText(lineItem.title, normalized)
          || includesText(lineItem.majorRequirement, normalized)
          || includesText(lineItem.relatedInfo, normalized)
          || includesText(lineItem.performanceStandard, normalized)
        );
      }) ?? null;

      return {
        ...group,
        lineItems: nextLineItems,
      };
    })
    .filter((group) => (group.lineItems?.length ?? 0) > 0);
};
